// extracted by mini-css-extract-plugin
export default {"tabs":"burger-ingredients_tabs__8IJpQ","content":"burger-ingredients_content__u9Xgn"};